import { BaseResponse, MessageResponse } from 'common/types/api'
import api from 'core/api'

import { CreateNoteFarmVariables, EditFarmVariables, FarmBody, FarmGeocodeResponse, FarmResponse, FarmWeatherResponse } from './types'

export const getFarms = () => api.get<BaseResponse<FarmResponse | null>>('/farms/list')

export const createFarm = (body: FarmBody) => api.post<MessageResponse>('/farms', body)

export const editFarm = ({ body, farmId }: EditFarmVariables) =>
  api.patch<MessageResponse>(`/farms/${farmId}`, body)

export const removeFarm = (farmId: string) => api.delete<MessageResponse>(`/farms/${farmId}`)


export const getFarmsGeocode = () => api.get<BaseResponse<FarmGeocodeResponse | null>>('/farms/geocode')

export const createNoteFarm = ({ body, farmId }: CreateNoteFarmVariables) =>
  api.post<MessageResponse>(`/farms/${farmId}/note`, body)

export const getFarmsWeather = (farmId: string) => api.get<BaseResponse<FarmWeatherResponse | null>>(`/farms/${farmId}/weather`)

export const getFarmsReverseGeocode = ({ lat, lng }: { lat: number; lng: number }) =>
  api.get<BaseResponse<FarmGeocodeResponse | null>>('/farms/reverse-geocode', { params: { lat, lng } })